import { useMutation } from "@apollo/client/react";
import { GetApplicationContext } from "hooks/apollo/applicationContext/applicationContext.gql";
import useGetBlocks from "hooks/apollo/blocks/useGetBlocks";
import useRefetchWorkOrders from "hooks/apollo/workOrder/useRefetchWorkOrders";
import { useNotificationState } from "hooks/state";
import { useState } from "react";
import SyncErrorMessage from "./SyncErrorMessage";
import { SyncSites } from "./syncSites.gql";

export default function useSyncSites() {
  const { setNotification } = useNotificationState();
  const { refetch: refetchWorkOrders } = useRefetchWorkOrders();
  const { refetch: refetchBlocks } = useGetBlocks();
  const [isSyncing, setSyncing] = useState(false);

  const [syncSites] = useMutation(SyncSites, {
    onCompleted: (data) => {
      refetchWorkOrders();
      refetchBlocks();

      const {
        syncSites: { errors },
      } = data;

      setNotification(result(errors));

      setSyncing(false);
    },
    onError: () => {
      setNotification({
        title: "Network error. Try again.",
        type: "danger",
      });
      setSyncing(false);
    },
  });

  const sync = ({ syncAllSites }) => {
    setSyncing(true);

    return syncSites({
      update: (proxy, { data }) => {
        const { applicationContext } = proxy.readQuery({ query: GetApplicationContext });

        const { lastSyncedAt } = data.syncSites.syncResult;

        proxy.writeQuery({
          data: { applicationContext: { ...applicationContext, site: { ...applicationContext.site, lastSyncedAt } } },
          query: GetApplicationContext,
        });
      },
      variables: { syncAllSites },
    });
  };

  return { isSyncing, sync };
}

function result(errors) {
  if (errors.length > 0) {
    return {
      message: SyncErrorMessage(errors),
      title: "Unable to sync the following sites",
      type: "danger",
    };
  }
  return {
    isCloseable: true,
    message: "",
    title: "Syncing completed",
    type: "success",
  };
}
